import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {StatusModalComponent} from '../../../../modals/status-modal/status-modal.component';
import {Subject} from 'rxjs/Subject';
import {ActivatedRoute, Router} from '@angular/router';
import {HcaUserManagementService} from '../../../../../shared/_services/hca-user-management.service';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {ValidationService} from '../../../../../shared/_services/validation.service';
import {MarketingService} from '../../../../../shared/_services/marketing.service';
import {UtilService} from '../../../../../shared/_services/util.service';

@Component({
  selector: 'app-promotions-new-promo',
  templateUrl: './promotions-new-promo.component.html',
  styleUrls: ['./promotions-new-promo.component.scss']
})
export class PromotionsNewPromoComponent implements OnInit {
  ScratchCodeObj: any;
  hideAddGroupCode: boolean;
  promoDetails: any;
  errorMsg: any;
  @ViewChild('promoView') promoView: ElementRef;
  pointValueTypes: any[] = [];
  isNewPromo: boolean;
  hotels: any;
  promoData: any;
  promoCodeId: number;
  transactionTypes: any[] = [];
  promoForm: FormGroup = new FormGroup({
    promocodeId: new FormControl(),
    statusId: new FormControl(),
    promoName: new FormControl(),
    promoDesc: new FormControl(),
    transactionTypeId: new FormControl(),
    pointValueType: new FormControl(),
    points: new FormControl(),
    promoCodeTypeId: new FormControl(),
    isAutomatic: new FormControl(),
    codes: new FormArray([]),
    groupCodes: new FormArray([]),
    dateFrom: new FormControl(),
    dateTo: new FormControl(),
    status: new FormControl(),
    brandIds: new FormControl(),
    hotelIds: new FormControl(),
  });
  brands = [];
  selectedBrand: any;
  statusModal: BsModalRef;
  bsValue: Date;
  successMsg: string;
  bsConfig: Partial<BsDatepickerConfig> = {containerClass: 'theme-orange'};
  minDate = new Date();
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private utilService: UtilService,
    private modalService: BsModalService,
    private marketingService: MarketingService,
    private validationService: ValidationService,
    private hcaUserManagementService: HcaUserManagementService
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe)
      .subscribe(() => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action === 'action1') {
            if (this.statusModal.content.srcObject.type === 'promo-add') {
              if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status === 0) {
                const status = this.statusModal.content.srcObject.status === 0 ? 1 : 0;
                this.activateOrDeactivate(this.statusModal.content.srcObject.id, status);
              } else {
                this.router.navigate(['/marketing/promotions']).then();
              }
            }
          }
        }
      });
  }

  // for Print
  printCards(type, i) {
    const formArray = this.promoForm.controls['groupCodes'] as FormArray;
    const coins = this.promoForm.controls['points'].value;
    this.utilService.printPreview(formArray.at(i).get('codes').value, coins, type);
  }

  activateOrDeactivate(id, status) {
    this.marketingService.activateOrDeactivatePromos(id, status).subscribe(() => {
      this.router.navigate(['./marketing/promotions']).then();
    }, err => {
      console.error('Error while updating promotion status: ', err.message);
    });
  }

  convert2Array() {
    const data = this.utilService.dateParser(this.promoForm.value, ['dateFrom', 'dateTo']);
    const brandIds = [];
    const hotelIds = [];
    brandIds.push(parseInt(data.brandIds, 10));
    data.brandIds = brandIds;
    hotelIds.push(parseInt(data.hotelIds, 10));
    data.hotelIds = hotelIds;
    return data;
  }

  addPromo(isReset) {
    this.marketingService.addOrUpdatePromo(this.convert2Array()).subscribe(res => {
      if (res.error === 0) {
        this.successMsg = res && res.message ? res.message : 'Promo added successfully';
        setTimeout(() => {
          this.successMsg = '';
        }, 2000);
        if (isReset) {
          this.initForm();
        } else {
          this.router.navigate(['/marketing/promotions']).then();
        }
      }
    }, err => {
      this.errorMsg = err && err.message ? err.message : 'Error while creating loyalty programme';
      setTimeout(() => {
        this.errorMsg = '';
      }, 2000);
      console.error('Error while adding new promo: ', err.message);
    });
  }

  getPromoDetails(promoId) {
    this.marketingService.getPromoById(promoId).subscribe(res => {
      if (res.error === 0) {
        this.promoDetails = res.responseObj;
        this.initForm(this.promoDetails);
      }
    }, err => {
      console.error(`Error while fetching promo details for ${promoId}: `, err.message);
    });
  }

  getTransactionTypes() {
    this.marketingService.getTransactionTypes().subscribe(res => {
      if (res.error === 0) {
        if (res.responseObj && res.responseObj.length) {
          this.transactionTypes = res.responseObj;
        } else {
          this.transactionTypes = [];
        }
      }
    }, err => {
      this.transactionTypes = [];
      console.error('Error while fetching Scratch code: ', err.message);
    });
  }

  getPointValueTypes() {
    this.marketingService.getPointValueTypes().subscribe(res => {
      if (res.error === 0) {
        if (res.responseObj && res.responseObj.length) {
          this.pointValueTypes = res.responseObj;
        } else {
          this.pointValueTypes = [];
        }
      }
    }, err => {
      this.pointValueTypes = [];
      console.error('Error while fetching pointValue Types: ', err.message);
    });
  }

  getScratchCode(i) {
    const formArray = this.promoForm.controls['groupCodes'] as FormArray;
    this.ScratchCodeObj = formArray.at(i).value;
    this.marketingService.getScratchCode(formArray.at(i).get('quantity').value).subscribe(res => {
      if (res.error === 0) {
        this.clearCodes(i);
        const codeArray = formArray.at(i).get('codes') as FormArray;
        if (res.responseObj && res.responseObj.length) {
          res.responseObj.forEach(code => {
            codeArray.push(this.fb.group(code));
          });
        }

      }
    }, err => {
      console.error('Error while fetching Scratch code: ', err.message);
    });
  }

  getPromotionRules() {
    this.marketingService.getPromotionRules().subscribe(res => {
      if (res.error === 0) {
        this.promoData = res.responseObj;
        this.brands = this.promoData.brands;
        if (this.promoData && this.promoData.promoType && this.promoData.promoType.length && this.promoForm
          && this.promoForm.controls['promoCodeTypeId']) {
          const promotionType = this.promoForm.controls['promoCodeTypeId'];
          promotionType.setValue(this.promoData.promoType[0].promoCodeTypeId);
        }
      }
    }, err => {
      console.error('Error while fetching promotion rules: ', err.message);
    });
  }

  getHotelsByBrands() {
    if (this.promoForm && this.promoForm.controls && this.promoForm.controls['brandIds']) {
      this.selectedBrand = this.promoForm.controls['brandIds'].value;
    }
    this.hotels = [];
    let brandIds = [];
    if (this.selectedBrand) {
      if (this.selectedBrand instanceof Array) {
        brandIds = this.selectedBrand;
      } else {
        brandIds.push(this.selectedBrand);
      }
      this.hcaUserManagementService.getHotelsByBrand(brandIds).subscribe(
        res => {
          if (res.error === 0) {
            this.hotels = res.responseObj.filter(hotel => hotel.status === 'Active');
          } else {
            console.error('Get Hotels : ' + res.message);
          }
        }, err => {
          console.error(err);
        });
    }
  }

  get getHours() {
    const hours = [];
    for (let i = 1; i <= 24; i++) {
      hours.push(i);
    }
    return hours;
  }

  templateString(type, info) {
    return `${info} ${type}${info === 1 ? '' : 's'} selected`;
  }

  confirmClose() {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'promo-add',
      title: 'Confirm',
      message: this.isNewPromo ? 'Are you sure you want to cancel adding a new promo?' : 'Do you want to cancel modifying the promo?',
      status: null,
      action1: 'Yes',
      action2: 'No',
      action: '',
    };
  }

  openModalActivateDeactivate(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    const message = mode === 1 ? 'Are you sure you want to deactivate this promo?' : 'Are you sure you want to activate this promo?';
    const title = mode === 1 ? 'Deactivate Promo' : 'Activate Promo';
    const action1 = mode === 1 ? 'Deactivate' : 'Activate';
    const style = mode === 1 ? 'inactive' : 'active';
    const status = mode;
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'promo-add',
      title: title,
      message: message,
      status,
      id: [id],
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    };
  }

  getFormArray(controlName) {
    return this.promoForm.get(controlName) as FormArray;
  }

  getControls(controlName) {
    return this.getFormArray(controlName).controls;
  }

  setValidatorsByPromoTypeId(value) {
    if (value === 2) {
      if (this.isNewPromo) {
        this.addGroupCode(null);
        while (this.promoForm.controls['codes'].value.length !== 0) {
          (<FormArray>this.promoForm.controls['codes']).removeAt(0);
        }
      }
      this.promoForm.controls['isAutomatic'].setValidators(null);
      this.promoForm.controls['isAutomatic'].setValue('false', {emitEvent: false});
      this.promoForm.controls['isAutomatic'].updateValueAndValidity();
    } else {
      if (this.isNewPromo) {
        this.addCouponCode(null);
      }
      while (this.promoForm.controls['groupCodes'].value.length !== 0) {
        (<FormArray>this.promoForm.controls['groupCodes']).removeAt(0);
      }
      this.promoForm.controls['groupCodes'].setValidators(null);
      this.promoForm.controls['groupCodes'].updateValueAndValidity();
      this.promoForm.controls['isAutomatic'].setValidators([Validators.required]);
      this.promoForm.controls['isAutomatic'].updateValueAndValidity();
    }
  }

  formSubscription() {
    this.promoForm.controls['promoCodeTypeId'].valueChanges.subscribe(value => {
      this.promoForm.controls['isAutomatic'].setValue('true', {emitEvent: false});
      this.setValidatorsByPromoTypeId(value);
    });
    this.promoForm.controls['pointValueType'].valueChanges.subscribe(() => {
      this.promoForm.controls['points'].setValue('', {emitEvent: false});
    });
  }

  clearCodes(i) {
    const formArray = this.getFormArray('groupCodes');
    while (formArray.at(i).get('codes').value.length !== 0) {
      (<FormArray>formArray.at(i).get('codes')).removeAt(0);
    }
  }

  selectedHour(type, value, parentIdx) {
    const formArray = this.getFormArray('groupCodes');
    formArray.at(parentIdx).get('duration').setValue(value);
  }

  valueChanges(type, i) {
    const formArray = this.getFormArray('groupCodes');
    const formGroup = formArray.at(i) as FormGroup;
    if (this.ScratchCodeObj) {
      if (formGroup.controls[type].value && this.ScratchCodeObj[type]) {
        if (formGroup.controls[type].value !== this.ScratchCodeObj[type]) {
          while (formGroup.controls['codes'].value.length !== 0) {
            (<FormArray>formGroup.controls['codes']).removeAt(0);
          }
        }
      }
    }
  }

  addGroupCode(data) {
    const codes: FormArray = new FormArray([], this.validationService.minLengthArray(1));
    const formArray = this.getFormArray('groupCodes');
    if (data && data.codes && data.codes.length) {
      data.codes.forEach(code => {
        codes.push(this.fb.group(code));
      });
    }
    formArray.push(this.fb.group({
      codes: codes,
      duration: [data ? data.duration : null, Validators.required],
      groupId: [data ? data.groupId : null],
      maxShare: [data ? data.maxShare : null, [Validators.required, Validators.min(1),
        Validators.max(10)]],
      quantity: [data ? data.quantity : null, [Validators.required, Validators.min(1),
        Validators.max(100)]],
    }));
  }

  addCouponCode(data) {
    const formArray = this.promoForm.get('codes') as FormArray;
    formArray.push(this.fb.group({
      code: [data ? data.code : null, [Validators.required, Validators.maxLength(30)]],
      duration: [data ? data.duration : null],
      promoCodeDataId: [data ? data.promoCodeDataId : null],
      generated: [data ? data.generated : null],
      promoStartDate: [data ? data.promoStartDate : null],
      promoEndDate: [data ? data.promoEndDate : null]
    }));
  }

  initForm(data?) {
    this.promoForm = new FormGroup({
      promocodeId: new FormControl(data ? data.promocodeId : ''),
      statusId: new FormControl(data ? data.statusId : ''),
      promoName: new FormControl(data ? data.promoName : '', [Validators.required, Validators.maxLength(60)]),
      promoDesc: new FormControl(data ? data.promoDesc : '', [Validators.required, Validators.maxLength(250)]),
      transactionTypeId: new FormControl(data && data.transactionTypeId ? data.transactionTypeId : '', [Validators.required]),
      pointValueType: new FormControl(data && data.pointValueType ? data.pointValueType : 1, [Validators.required]),
      points: new FormControl(data ? data.points : '', [Validators.required, this.validationService.maxLength(10)]),
      promoCodeTypeId: new FormControl(data ? data.promoCodeTypeId : 1, [Validators.required]),
      isAutomatic: new FormControl(data && (data.isAutomatic !== null || data.isAutomatic !== '') ? data.isAutomatic.toString() : 'true'),
      codes: new FormArray([]),
      groupCodes: new FormArray([]),
      dateFrom: new FormControl(data ? data.dateFromStr : '', [Validators.required]),
      dateTo: new FormControl(data ? data.dateToStr : '', [Validators.required]),
      status: new FormControl(data ? data.status : ''),
      brandIds: new FormControl(data ? data.brandIds : '', [Validators.required]),
      hotelIds: new FormControl(data ? data.hotelIds : '', [Validators.required]),
    }, this.validationService.dateLessThan('dateFrom', 'dateTo'));
    if (data) {
      if (data.promoCodeTypeId === 1 && data.codes && data.codes.length) {
        this.addCouponCode(data.codes[data.codes.length - 1]);
      }
      this.promoForm.controls['groupCodes'].valueChanges.subscribe(value => {
        if (value && !this.isNewPromo && this.promoDetails) {
          if (this.promoDetails.promoCodeTypeId === 2) {
            if (this.promoDetails.groupCodes && value) {
              if ((this.promoDetails.groupCodes.length + 1) === value.length) {
                this.hideAddGroupCode = true;
              }
            }
          }
        }
      });
      if (data.promoCodeTypeId === 2 && data.groupCodes && data.groupCodes.length) {
        data.groupCodes.forEach(code => {
          this.addGroupCode(code);
        });
      }
      if (data.promoCodeTypeId) {
        this.setValidatorsByPromoTypeId(data.promoCodeTypeId);
      }
    }
    this.getHotelsByBrands();
    this.formSubscription();
  }

  ngOnInit() {
    this.bsValue = new Date();
    this.getPromotionRules();
    this.getPointValueTypes();
    this.getTransactionTypes();
    this.route.params.subscribe(params => {
      this.promoCodeId = +params['id']; // (+) converts string 'id' to a number
      if (this.promoCodeId) {
        this.isNewPromo = false;
        this.getPromoDetails(this.promoCodeId);
      } else {
        this.isNewPromo = true;
        this.initForm();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/marketing/promotions-new-promo/promotions-new-promo.component.ts